import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

export const BOOKING_URL =
  "https://bookings.cloud.microsoft/bookwithme/user/3eec5c362d4f4a0593610b24fa15439e@seniorsimplement.com/meetingtype/hdlo8-WVw0mj94Tq5oH1pQ2?anonymous&ismsaljsauthenabled&ep=mCardFromTile";

const ease = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 32, className }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.8, delay, ease }}
  >
    {children}
  </motion.div>
);

export const SectionTag = ({ num, label, light }) => (
  <Reveal className="flex items-center gap-4 mb-6">
    <span className={`section-num ${light ? "section-num-light" : ""}`}>{num}</span>
    <span className={`section-label ${light ? "section-label-light" : ""}`}>{label}</span>
    <span className={`h-px flex-1 max-w-[120px] ${light ? "bg-white/20" : "bg-[#0b1b2b]/15"}`} />
  </Reveal>
);

export const CtaButton = ({ children, testId, invert, className = "" }) => (
  <a
    href={BOOKING_URL}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={testId}
    className={`cta-btn ${invert ? "cta-btn-invert" : ""} ${className}`}
  >
    <span>{children}</span>
    <ArrowRight className="w-4 h-4 cta-arrow" strokeWidth={2.5} />
  </a>
);
